import type { Profile } from "~/data/profiles"
import { getAllSanityProfiles } from "~/lib/server-fns"

export async function fetchAllProfiles(): Promise<Profile[] | null> {
  if (typeof window === "undefined") {
    return getAllSanityProfiles({ data: {} })
  }
  const res = await fetch("/api/profiles")
  if (!res.ok) return null
  return (await res.json()) as Profile[]
}
